import { Injectable } from '@angular/core';
import { ServiceService } from '../service.service';

@Injectable({
  providedIn: 'root'
})
export class PublicService {

  constructor(private servi: ServiceService) { }

  public getServe() { return this.servi.server; }

  
  public GetListadoConsejoPrograma() {
    return this.servi.get_p('PublicCOGUI/GetConsejoProgramas_Listado');
  }

  public GetBusqueda() {
    return this.servi.get_p('PublicCOGUI/getBusqueda');
  }

  public GetBusquedaDocumentos() {
    return this.servi.get_p('PublicCOGUI/getBusquedaDocumento');
  }

  public GetNotificaciones() {
    return this.servi.get_p('PublicCOGUI/getNotificaciones');
  }

  public GetDocumentosGrado() {
    return this.servi.get_p('PublicCOGUI/GetDocumentosGrado');
  }
  // public GetCircularesGrado(){
  //   return this.servi.get_p('PublicCOGUI/GetCircularesGrado');
  // }

  public GetFiltrarNormasPublica(data) {
    return this.servi.post_p('PublicCOGUI/GetFiltrarNormasPublica', data);
  }

  public GetFiltrarDocumentos(data) {
    return this.servi.post_p('PublicCOGUI/GetFiltrarDocumentos', data);
  }

  public getDetalle(id) {
    return this.servi.get_p('PublicCOGUI/detalleNorma/'+ id);
  }

  public GetIndexNovedades() {
    return this.servi.get_p('PublicCOGUI/GetIndexNovedades');
  }

  public getDatosSolicitud() {
    return this.servi.get_p('PublicCOGUI/getDatosSolicitud');
  }

  public getConsultaGrado(data) {
    return this.servi.post_p('PublicCOGUI/getConsultaGrado/',data);
  }
  public getBusquedaTipoDocumento(id) {
    return this.servi.get_p('PublicCOGUI/getBusquedaTipoDocumento/'+id );
  }
  
  public getBusquedaTramiteCiudadano() {
    return this.servi.get_p('PublicCOGUI/getBusquedaTramiteCiudadano');
  }
  public getFiltrarTramites(data){
    return this.servi.post_p('PublicCOGUI/getFiltrarTramites/', data)
  }
  public getTiposTramites() {
    return this.servi.get('PublicCOGUI/getTiposTramites'); }

  public suscripciones(data){
    return this.servi.post_p('PublicCOGUI/suscripcion/', data)
  }

  public PlanesDeGobierno(){
    return this.servi.get_p('PublicCOGUI/PlanesDeGobierno');
  }

  public PoliticasInstitucionales(id) {
    return this.servi.get_p('PublicCOGUI/PoliticasInstitucionales/' + id);
  }

  public FactoresAcreditacion() {
    return this.servi.get_p('PublicCOGUI/FactoresAcreditacion');
  }

  public PoliticasNorma(id) {
    return this.servi.get_p('PublicCOGUI/PoliticasNorma/'+id);
  }

  public FactoresNorma(id) {
    return this.servi.get_p('PublicCOGUI/FactoresNorma/' + id);
  }

  public detalleHTMLnorma(id) {
    return this.servi.get_p('PublicCOGUI/DetalleHTMLNorma/' + id);
  }

  public Sensibilizacion(){
    return this.servi.get_p('PublicCOGUI/getSensibilizacion');
  }

  public Logros(){
    return this.servi.get_p('PublicCOGUI/getLogros');
  }

  public getDetalleTramite(id){ return this.servi.get('PublicCOGUI/getDetalleTramite/' +id); } 


}
